/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../utilities/Tools.js";

class DropdownMenu {
    constructor() {
        this.navLinks = document.querySelectorAll('[data-js-navbar="nav-link"]');
        this.observers = {};
        this.timeout = null;

        //
        this.init();
    }

    events() {
        const _this = this;

        jQuery(window).on("resize", function (event) {
            clearTimeout(_this.timeout);

            _this.timeout = setTimeout(function () {
                let activeDropdownMenu = jQuery(".dropdown-menu.show");

                if (activeDropdownMenu.length === 1) {
                    _this.removeColumnsInDropdownMenu(activeDropdownMenu);
                    _this.setColumnsInDropdownMenu(activeDropdownMenu);
                }
            }, 66);
        });
    }

    initMutationObserver() {
        const _this = this;

        jQuery.each(this.navLinks, function (index, navLink) {
            _this.observers["_" + index] = new MutationObserver(function (event) {
                let isSubMenuExpanded = JSON.parse(jQuery(event[0].target).attr("aria-expanded"));

                if (isSubMenuExpanded) {
                    _this.setColumnsInDropdownMenu(jQuery(event[0].target).next());
                } else {
                    _this.removeColumnsInDropdownMenu(jQuery(event[0].target).next());
                }
            });

            _this.observers["_" + index].observe(navLink, {
                attributeFilter: ["aria-expanded"],
                subtree: false,
                childList: false,
            });
        });
    }

    getDropdownMenuBottomPos(dropdownMenu) {
        return dropdownMenu[0].getBoundingClientRect().height + dropdownMenu[0].getBoundingClientRect().top;
    }

    getDropdownMenuRightPos(dropdownMenu) {
        return dropdownMenu[0].getBoundingClientRect().width + dropdownMenu[0].getBoundingClientRect().left;
    }

    setColumnsInDropdownMenu(dropdownMenu, newNumberOfColumns = null) {
        if (!Tools.matchMedia("(min-width: 992px)")) {
            return false;
        }

        if (dropdownMenu.parent().hasClass("dropdown-static")) {
            return false;
        }

        if (this.getDropdownMenuBottomPos(dropdownMenu) > jQuery(window).height()) {
            let numberOfColumns = 1;

            if (newNumberOfColumns === null) {
                numberOfColumns++;
            } else {
                numberOfColumns = newNumberOfColumns;
                numberOfColumns++;
            }

            dropdownMenu.css({
                "column-count": numberOfColumns.toString(),
            });

            if (this.getDropdownMenuRightPos(dropdownMenu) > jQuery(window).width()) {
                numberOfColumns--;
                dropdownMenu.css({
                    "column-count": numberOfColumns.toString(),
                });

                return false;
            }

            this.setColumnsInDropdownMenu(dropdownMenu, numberOfColumns);
            return false;
        }
    }

    removeColumnsInDropdownMenu(dropdownMenu) {
        if (dropdownMenu.parent().hasClass("dropdown-static")) {
            return false;
        }

        dropdownMenu.removeAttr("style");
    }

    init() {
        this.events();
        this.initMutationObserver();
    }
}

export { DropdownMenu };
